
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homeseller",
      function () {
        return require("private-next-pages/homeseller/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homeseller"])
      });
    }
  